import { useEffect, useState } from "react";

import useAxios from "@hooks/use-axios";
import { useParams } from "react-router-dom";
import useSearchParams from "@hooks/use-search-params";

const useResponse = () => {

    const { platformId } = useParams();

    const { axiosInstance, loading, cancelAllRequests } = useAxios({
        base         : "panel",
        initialLoader: true
    });
    
    const { getSearchParams } = useSearchParams();

    const [data, setData] = useState({
        csat_stats     : {},
        responses      : {},
        survey_name    : "",
        survey_type    : "",
        total_responses: 0,
        promoter_stats : {}
    });
    const { survey_id } = useParams();

    const getSurveyResponse = async survey_id => {
        const { data } = await axiosInstance.get(
            `/survey/${platformId}/response/${survey_id}`,
            {
                params: {
                    page : getSearchParams("page"),
                    limit: getSearchParams("limit")
                }
            }
        );
        setData(data);
    };
    useEffect(() => {
        if (survey_id) getSurveyResponse(survey_id);
        return () => {
            cancelAllRequests();
        };
    }, [survey_id]);

    return {
        getSurveyResponse,
        data,
        loading
    };
};
export default useResponse;